var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMirrorPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.544,
    height: 103,
    viewBox: "0 0 160.544 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MIRROR",
    transform: "translate(4.242 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pencil-alt-solid",
    d: "M78.772,22.539l-7.292,7.292a1.9,1.9,0,0,1-2.689,0L51.235,12.274a1.9,1.9,0,0,1,0-2.689l7.292-7.292a7.608,7.608,0,0,1,10.74,0L78.772,11.8A7.58,7.58,0,0,1,78.772,22.539Zm-33.8-6.691L3.436,57.384.083,76.6A3.8,3.8,0,0,0,4.48,81L23.7,77.629,65.233,36.094a1.9,1.9,0,0,0,0-2.689L47.676,15.848a1.919,1.919,0,0,0-2.7,0ZM19.649,53.825a2.205,2.205,0,0,1,0-3.132L44.007,26.335a2.214,2.214,0,1,1,3.132,3.132L22.78,53.825a2.205,2.205,0,0,1-3.132,0Zm-5.71,13.3h7.592v5.742l-10.2,1.787L6.41,69.737,8.2,59.535h5.742Z",
    transform: "translate(75.3 15.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M52.755,16.47,63.128,25.6l3.312,18.98A3.754,3.754,0,0,1,62.1,48.924L43.117,45.6,34.234,35.224c-.734-.734,17.8-19.471,18.521-18.754Zm0,18.754h-7.5v5.671L55.333,42.66,60.191,37.8,58.426,27.726H52.755Z",
    transform: "translate(-4.175 47.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M0,97V0",
    transform: "translate(69.325)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M0,51.846V0",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 0, 48.093)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6,
    strokeDasharray: "3 10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M0,51.846V0",
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 15, 34.093)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6,
    strokeDasharray: "3 10"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorPen);
export default __webpack_public_path__ + "static/media/mirror_pen.51e8cc361216951939a27269a2a99b5f.svg";
export { ForwardRef as ReactComponent };